import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

const AndroidAppPopup = ({ targetUrl }) => {
  const [showPopup, setShowPopup] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const isAndroid = /Android/i.test(navigator.userAgent);
    const isLoggedIn = localStorage.getItem("token") !== null;

    if (isAndroid && !isLoggedIn) {
      setShowPopup(true);
    }
  }, []);

  const handleOpenInApp = () => {
    window.location.href = `intent://${targetUrl.replace(
      "https://",
      ""
    )}#Intent;scheme=https;package=com.hyderabadcastingclub.android;end`;
  };

  const handleLoginRedirect = () => {
    setShowPopup(false); // hide the Android app popup first
    setTimeout(() => {
      const loginTrigger = document.querySelector(".login-text");
      if (loginTrigger) {
        loginTrigger.click(); // open the login modal
      }
    }, 100); // slight delay to let the popup close first
  };

  if (!showPopup) return null;

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        backgroundColor: "rgba(0,0,0,0.5)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 9999,
      }}
    >
      <div
        style={{
          backgroundColor: "#fff",
          borderRadius: "12px",
          padding: "24px",
          width: "90%",
          maxWidth: "350px",
          textAlign: "center",
          position: "relative",
        }}
      >
        <button
          onClick={() => setShowPopup(false)}
          style={{
            position: "absolute",
            top: "10px",
            right: "10px",
            background: "transparent",
            border: "none",
            fontSize: "18px",
            cursor: "pointer",
          }}
        >
          ✕
        </button>
        <h3 style={{ marginBottom: "12px" }}>Get the Best Experience!</h3>
        <p style={{ marginBottom: "20px", fontSize: "14px", color: "#555" }}>
          Open in our mobile app or log in for more features.
        </p>
        <button
          onClick={handleOpenInApp}
          style={{
            backgroundColor: "#f44336",
            color: "#fff",
            padding: "12px 20px",
            border: "none",
            borderRadius: "8px",
            width: "100%",
            marginBottom: "12px",
            fontSize: "16px",
            cursor: "pointer",
            fontWeight: "600",
          }}
        >
          OPEN IN APP
        </button>
        <button
          onClick={handleLoginRedirect}
          style={{
            backgroundColor: "#2196f3",
            color: "#fff",
            padding: "10px 20px",
            border: "none",
            borderRadius: "8px",
            width: "100%",
            fontSize: "14px",
            cursor: "pointer",
            fontWeight: "600",
          }}
        >
          LOGIN
        </button>
      </div>
    </div>
  );
};

export default AndroidAppPopup;
